module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b77fe5cbd17bd82c89a19667e015cb4c.gif";